import { useState, useEffect } from 'react';
import { Table, Column } from '@tencent/spaui';
import { PROGRESS_STATUS } from '@/constants/Constants';
import { getReceiveRecord } from './api';
import CleaningStatus from '@/components/CleaningStatus';
import PotentialStatus from '@/components/PotentialStatus';
import OrderStatus from '@/business-components/sale/OrderStatus';
import DateTime from '@/components/DateTime';
import OverflowHoverTip from '@/common-components/overflow-hover-tip';
import FileList from '@/pages/agency/manage/material/components/file-list';
import useContentPreview from '@/common/hooks/use-content-preview';
import { getMessage } from '@/utils/MessageUtils';
import '@/pages/agency/manage/material/assets/index.scoped.less';

interface ReceiveRecordProps {
  leadId: number;
}

const ReceiveRecordPanel = (props: ReceiveRecordProps) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { contentPreview, imageViewer } = useContentPreview();

  const getData = () => {
    setLoading(true);
    if (!props.leadId) return;
    getReceiveRecord({
      leadId: props.leadId,
    })
      .then((res: any) => {
        if (res.code === 0) {
          setData(res?.data || []);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [props.leadId]);

  const renderColumn = (type: string, name: string, value: any, data: any) => {
    if (type === 'head') {
      return value;
    }
    switch (name) {
      case 'progressStatus':
        switch (value) {
          case PROGRESS_STATUS.PROGRESS_STATUS_LEAD:
            return <span>线索-<CleaningStatus cleaningStatus={data?.cleaningStatus} /></span>;
          case PROGRESS_STATUS.PROGRESS_STATUS_POTENTIAL:
            return <span>商机-<PotentialStatus potentialStatus={data?.potentialStatus} transactionProbability={data?.transactionProbability} /></span>;
          case PROGRESS_STATUS.PROGRESS_STATUS_ORDER:
            return <span>订单-<OrderStatus orderStatus={data?.orderStatus} /></span>;
          default:
            return '-'
        }
      case 'sendTime':
        return <DateTime dateTime={value} />;
      case 'materialDetails':
        return <div className='material-list'>
          <OverflowHoverTip maxWidth={480} tip={value?.textMessage || ''}><span>{value?.textMessage || ''}</span></OverflowHoverTip>
          <FileList data={value?.fileItems || []} onPreview={contentPreview} />
        </div>;
      case 'type':
        return getMessage(value, 'LeadReceiveRecordType');
      case 'status':
        return getMessage(value, 'LeadReceiveRecordStatus');
      default:
        return value;
    }
  }

  return (
    <>
      <Table bordered data={data} loading={loading}>
        <Column name="progressStatus" render={renderColumn}>
          阶段-状态
        </Column>
        <Column name="sendTime" render={renderColumn}>时间</Column>
        <Column name="materialDetails" render={renderColumn}>发送内容</Column>
        <Column name="customer.name">接收人</Column>
        <Column name="employeeName">发送人</Column>
        <Column name="type" render={renderColumn}>类型</Column>
        <Column name="status" render={renderColumn}>发送状态</Column>
      </Table>
      {imageViewer}
    </>
  );
};

export default ReceiveRecordPanel;
